import { useCallback, useRef, useState } from "react";
import "../styles/main.scss";
import Report from "./Report";
import DeleteReportModal from "./DeleteReportModal";
import useDataFetch from "hooks/dataFetch";
import { reportsService } from "../services/reports.service";
import { IReport } from "../domain/IReport";
import Loader from "components/Loader/Loader";

interface IProps {
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
};

const ReportsTooltip = ({ setClickOutsideActive }: IProps) => {
  const limit = 10;
  const [afterId, setAfterId] = useState<number | undefined>(undefined);
  const [beforeId, setBeforeId] = useState<number | undefined>(undefined);
  const { data, hasMoreAfter, loadingAfter, loadingBefore } =
    useDataFetch<IReport>(
      reportsService.getAllReports,
      limit,
      afterId,
      beforeId
    );

  const observer = useRef<IntersectionObserver>();

  const lastElementRef = useCallback(
    (node: any) => {
      if (loadingAfter) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreAfter) {
          setAfterId(data[data.length - 1].reportId);
        }
      });
      if (node) observer.current.observe(node);
    },
    [data, loadingAfter, hasMoreAfter]
  );

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    if (e.currentTarget.scrollTop === 0) {
      if (loadingBefore) return;
      setBeforeId(data[0].reportId);
    }
  };

  return (
    <div id="reports-tooltip" onScroll={handleScroll}>
      {loadingBefore && <Loader />}
      {data.map((report, index) => (
        <Report
          report={report}
          index={index}
          key={`${report.reportId}`}
          isLast={index === data.length - 1}
          lastElementRef={lastElementRef}
        />
      ))}
      {loadingAfter && <Loader />}
      <DeleteReportModal setClickOutsideActive={setClickOutsideActive} />
    </div>
  );
};

export default ReportsTooltip;
